module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDM1IDM2Ij4KICAgIDxwYXRoIGZpbGw9IiM0QTkwRTIiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xMi44MzcgMjIuODczTDI2Ljk4MSAyLjU3YzEuMjEtMS43MTUgMy41NDYtMi4wODUgNS4xOTgtLjgxNCAxLjYyNiAxLjI1MiAxLjk3IDMuNjIuNzc1IDUuMzEzTDEzLjU3IDM0LjE0MmwtLjgzMy0uNzg0LTkuODQ2LTkuMjcyYy0xLjQyNi0xLjQ4NS0xLjQzLTMuODc4LS4wMDgtNS4zNjcgMS40MTEtMS40NzggMy41NS0xLjQ1IDUuMjMzLS4wODYuNzguNjMyIDIuMzQ5IDIuMDQxIDQuNzIxIDQuMjR6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v-blue.svg
// module id = tZyQ
// module chunks = 6